import { AdobeEvent, AnalyticsAdapter } from './typing'
import getDataLayerArray from './getDataLayer'
import analytics from './optum-match'
import { useFlags } from 'launchdarkly-react-client-sdk'

export {
  OM_EVENTS,
  PATIENT_EVENTS,
  CLINICIAN_EVENTS,
  SHARED_EVENTS,
  EVENTS,
  INTENT_EVENTS,
  formatClinicianProfileEventName,
} from './events'

const useAdobeAnalytics = (): AnalyticsAdapter => {
  const { enableAdobeAnalytics } = useFlags()
  const isAdobeEnabled = enableAdobeAnalytics
  const dataLayer: AdobeEvent[] = getDataLayerArray(isAdobeEnabled)
  const baseAction = (event: AdobeEvent) => {
    // ALWAYS push to data layer for debugging (regardless of LaunchDarkly flag)
    try {
      dataLayer.push(event)
    } catch (err) {
      // silently ignore errors
    }
  }

  return analytics(baseAction)
}

export default useAdobeAnalytics
